import React from 'react'
import { IconContext } from 'react-icons'
import { FaCloud } from 'react-icons/fa'

const AccountsIcon = () => {
  return (
    <IconContext.Provider value={{ color: "white", size: "5em" }}>
      <div>
        <FaCloud />
      </div>
    </IconContext.Provider>
  )
}

export default AccountsIcon
